import { useCallback, useEffect, useRef, useState } from "react";
import * as XLSX from "xlsx";
import {
  addDaoTrang,
  editDaoTrang,
  selectActiveDaoTrangId,
  selectDaoTrangById,
  selectKeys,
  selectMembers,
  selectSheetData,
  selectSheetHdr,
  selectThanhPhans,
  setActiveDaoTrang,
  setCellData,
  setDaoTrangId,
  setDaoTrangs,
  setKeys,
  setMembers,
  setSheetData,
  setThanhPhans,
  updateActiveDaoTrang,
} from "../../features/daoTrang/daoTrangSlice";
import { timeParser } from "../../utils/timerUtil";
import { useAppDispatch, useAppSelector } from "../../app/hooks";
import { selectToken } from "../../features/auth/authSlice";
import {
  Alert,
  Box,
  Button,
  Dialog,
  DialogContent,
  DialogTitle,
  Grid,
  IconButton,
  Snackbar,
  Stack,
  Typography,
} from "@mui/material";
import { UserTable } from "./UserTable";

import classes from "./DaoTrang.module.css";
import { BigSpin } from "./BigSpin";
import { refineSheet } from "../../utils/taskUtil";
import { Content } from "../Content/Content";
import {
  createUser,
  getAllMembers,
  getMembers,
  removeUser,
  saveOrCreateUser,
  updateUser,
  USER_FIELDS,
} from "../../services/user/userApi";
import { userFromMongo } from "../../utils/mongoUtil";
import { UserSearchBar } from "./UserSearchBar";
import {
  informNg,
  informOk,
} from "../../features/notification/notificationSlice";
import { MyContainer } from "../Layout/MyContainer";
import {
  getDaoTrang,
  saveDaoTrang,
  updateDaoTrang,
} from "../../services/daoTrang/daoTrangApi";
import { Notify } from "../dialog/AlertDialog";
import UserTag from "./UserTag";
import UserCard from "./UserCard";
import ImportUserStep from "./ImportUserStep";
import CloseIcon from "@mui/icons-material/Close";
import UserEdit from "./UserEdit";
import EditUserDialog from "./EditUserDialog";
import AddUserDialog from "./AddUserDialog";
import AddUserCard from "./AddUserCard";
import { useMemberDiffOptimized } from "./useMemberDiffOptimized";
import { useNotify } from "../hooks/useNotify";
import { NotifySnackbar } from "../dialog/NotifySnackbar";
import { addUser, addUsers, deleteUser, editUser, selectUsers } from "../../features/user/userSlice";

function filterMembers(members, keys) {
  const filter = [];
  members?.forEach((u) => {
    if (keys.some((key) => u.email.includes(key) || u.name.includes(key))) {
      filter.push(u);
    }
  });
  return filter;
}
function createOptions(members) {
  const options = [];
  members?.forEach((u) => {
    if (!options.includes(u.email)) {
      options.push(u.email);
    }
  });
  return options;
}
function getRenderData(members, keys, thanhPhan) {
  var lst = [];
  lst = keys.length === 0 ? [...members] : filterMembers(members, keys);
  if (thanhPhan) {
    lst = lst.filter((u) => u.thanhPhan === thanhPhan);
  }
  lst.sort(
    (a, b) =>
      a.thanhPhan.localeCompare(b.thanhPhan) || a.email.localeCompare(b.email),
  );
  return lst;
}
const ImportButton = ({ onFileInput }) => {
  const inputRef = useRef(null);
  return (
    <>
      <input ref={inputRef} type="file" onInput={onFileInput} hidden={true} />
      <Button
        variant="contained"
        onClick={() => {
          inputRef.current?.click();
        }}
      >
        Import
      </Button>
    </>
  );
};

const userFieldKeys = USER_FIELDS.map((u) => u.key);

const DaoTrang = ({ navigate, params = {} }) => {
  let { id: daoTrangId } = params; // daotrang id
  console.log(`DaoTrang/${daoTrangId}`);

  const [loadingState, setLoadingState] = useState("idle");
  const [workbook, setWorkbook] = useState();
  const keys = useAppSelector(selectKeys);
  const [thanhPhan] = useAppSelector(selectThanhPhans);

  const dispatch = useAppDispatch();

  const sheetData = useAppSelector(selectSheetData);
  const sheetHdr = useAppSelector(selectSheetHdr);
  const token = useAppSelector(selectToken);
  const users = useAppSelector(selectUsers);
  const activeDaoTrangId = useAppSelector(selectActiveDaoTrangId);

  const [memberAccounts, setMemberAccounts] = useState([]);
  const [localMembers, setLocalMembers] = useState([]);
  const [localMemberAccounts, setLocalMembersAccounts] = useState([]);

  const [openEdit, setOpenEdit] = useState(false);
  const [editingUser, setEditingUser] = useState(null);
  const [openAdd, setOpenAdd] = useState(false);

  // navigate form memnu: daoTrangId = undefined
  if (!daoTrangId) {
    daoTrangId = activeDaoTrangId;
  }

  const daoTrang = useAppSelector((s) => selectDaoTrangById(s, daoTrangId));

  const {
    notify,
    success: notifySuccess,
    error: notifyError,
    close,
  } = useNotify();

  const { stateMap, hasChanges } = useMemberDiffOptimized(
    memberAccounts,
    localMemberAccounts,
  );

  // useEffect(() => {
  //   if (!workbook) return;

  //   var allSh = [];
  //   workbook.SheetNames.forEach((shName) => {
  //     var worksheet = workbook.Sheets[shName];
  //     var jsonData = XLSX.utils.sheet_to_json(worksheet, {
  //       header: 1,
  //       defval: "",
  //       cellDates: true,
  //     });
  //     allSh.push(jsonData);
  //   });
  //   // setSheets(allSh);
  //   var { sheetData, sheetHdr } = refineSheet(allSh[0]);
  //   dispatch(setSheetHdr({ sheetHdr }));
  //   dispatch(setSheetData({ sheetData }));
  // }, [dispatch, workbook]);

  // load dao trang by id
  useEffect(() => {
    async function loadDaoTrang(id) {
      const { error, result } = await getDaoTrang(id);
      if (result) {
        dispatch(setDaoTrangId({ daoTrangId: id }));
        dispatch(addDaoTrang({ daoTrang: result }));
      } else {
        console.log(`get daotrang ${id} error: ${error}`);
      }
    }
    if (daoTrangId) {
      console.log("load dao trang");
      loadDaoTrang(daoTrangId);
    } else {
      console.log("skip load dao trang");
    }
  }, [daoTrangId, dispatch]);

  // load member
  const loadMember = useCallback(
    async function (daoTrangId) {
      try {
        setLoadingState("loading");

        // ✅ Không có member thì dừng sớm
        if (!Array.isArray(daoTrang?.members)) return;

        // ==== 1. Chuẩn bị dữ liệu ====

        // Members đã tồn tại trong local users
        const existingMembers = [];

        // Account chưa có trong local → cần fetch từ server
        const accountsToFetch = [];

        // Map users theo email để lookup O(1)
        const usersByEmail = new Map(users.map((u) => [u.email, u]));

        // Phân loại members: đã tồn tại vs cần fetch
        daoTrang.members.forEach((accountEmail) => {
          if (usersByEmail.has(accountEmail)) {
            existingMembers.push(usersByEmail.get(accountEmail));
          } else {
            accountsToFetch.push(accountEmail);
          }
        });

        if (accountsToFetch.length === 0) return;

        // ==== 2. Chia batch để gọi API (tránh quá tải) ====

        const BATCH_SIZE = 10;
        const accountBatches = [];

        for (let i = 0; i < accountsToFetch.length; i += BATCH_SIZE) {
          accountBatches.push(accountsToFetch.slice(i, i + BATCH_SIZE));
        }

        // ==== 3. Fetch members theo batch ====

        const batchResults = await Promise.all(
          accountBatches.map(async (accounts) => {
            const { result, error } = await getMembers(accounts);
            if (error) {
              throw new Error(error);
            }
            return result; // ✅ mỗi batch trả về array user
          }),
        );

        // Gộp kết quả fetch từ tất cả batch
        const fetchedMembers = batchResults.flat();

        // Lưu users mới vào store
        dispatch(addUsers(fetchedMembers));

        // ==== 4. Gộp toàn bộ members của daoTrang ====

        const daoTrangMembers = existingMembers.concat(fetchedMembers);

        // dispatch(
        //   setActiveDaoTrang({
        //     daoTrangId,
        //     members: daoTrangMembers,
        //   }),
        // );

        return { result: daoTrangMembers };
      } catch (err) {
        console.error(err.message);
        return { error: err.message };
      } finally {
        setLoadingState("idle");
      }
    },
    [daoTrang?.members, dispatch, users],
  );

  useEffect(() => {
    // if navigate form memnu: daoTrangId = activeDaoTrang
    if (!daoTrangId) {
      // if activeDaoTrang is not specified, redirect to home
      navigate("/DaoTrangList");
      return;
    }

    // if navigate form menu: daoTrangId = activeDaoTrangId => skip load data
    // if (activeDaoTrangId !== daoTrangId) {
    // if change daoTrang form page "DaoTrangLst" => load data
    console.log("load members");
    loadMember(daoTrangId);
    // } else {
    //   // skip reload
    //   console.log("skip load members");
    // }
  }, [daoTrangId, dispatch, loadMember, navigate, token]);

  // update memberAcct, localMemberAcct
  useEffect(() => {
    if (!Array.isArray(daoTrang?.members)) return;

    setLocalMembersAccounts(daoTrang.members);
    setMemberAccounts(daoTrang.members);
    console.log("update local member ", daoTrang.members);
  }, [daoTrang?.members]);

  // update local member
  useEffect(() => {
    // ✅ Map email -> user (lookup O(1))
    const userMap = new Map(users.map((u) => [u.email, u]));

    // ✅ Map member email -> user, loại bỏ null
    const localMembers = localMemberAccounts
      .map((email) => userMap.get(email))
      .filter(Boolean);

    setLocalMembers(localMembers);
  }, [localMemberAccounts, users]);

  const onFileInput = useCallback(
    async (e) => {
      try {
        console.log("onFileInput");
        if (e.target.files.length === 0) {
          return;
        }

        // setFile(e.target.files);

        setLoadingState("loading");

        await xlsxImport(e, setWorkbook);
        var file = e.target.files[0];
        // var fr = new FileReader();
        // fr.onload = (e) => {
        // var raw = JSON.parse(e.target.result);
        var text = await file.text();
        var raw = JSON.parse(text);
        var lst = [];
        raw.forEach((u) => {
          if (u.daoTrang) {
            lst.push(userFromMongo(u));
          }
        });

        dispatch(setMembers({ members: lst }));
        // };
        // fr.readAsText(file);
      } catch (ex) {
        console.log(ex.message);
      } finally {
        setLoadingState("idle");
      }
    },
    [dispatch],
  );

  const openSheet = (shName) => {
    const worksheet = workbook.Sheets[shName];
    const jsonData = XLSX.utils.sheet_to_json(worksheet, {
      header: 1,
      defval: "",
    });
    refineSheet(jsonData);
  };
  const openSheetByIndex = (i) => {
    // const jsonData = sheets[i];
    // refineSheet(jsonData);
  };

  const onCellChange = (e, iRow, iCol) => {
    var val = e.target.innerHTML;
    console.log(iRow, iCol, val);
    try {
      if (val.match(/^\d{1,2}:\d{1,2}$/)) {
        var time = timeParser(val);
        sheetData[iRow][iCol] = time;
        setSheetData([...sheetData]);
      }
    } catch (ex) {
      console.log(ex.message);
    }
  };

  const onCellBlur = (e, iRow, iCol) => {
    var val = e.target.innerHTML;
    console.log(iRow, iCol, val);
    try {
      if (val.match(/^\d{1,2}:\d{1,2}$/)) {
        var time = timeParser(val);
        dispatch(setCellData([{ iRow, iCol, val: time }]));
      }
    } catch (ex) {
      console.log(ex.message);
    }
  };

  const onUploadTask = async () => {
    var wb = XLSX.utils.book_new();

    var hdr = sheetHdr.map((hdr) => hdr.name);
    var ws = XLSX.utils.aoa_to_sheet([hdr, ...sheetData]);

    var nCol = sheetHdr.length;
    var nRow = sheetData.length;
    for (var iCol = 0; iCol < nCol; iCol++) {
      if (sheetHdr[iCol].formater) {
        for (var iRow = 0; iRow < nRow; iRow++) {
          var cell = ws[XLSX.utils.encode_cell({ r: iRow + 1, c: iCol })];
          cell.z = "h:mm;@";
        }
      }
    }

    // var table = document.getElementById("order-tbl");
    // var table = tbl.current
    // var ws = XLSX.utils.table_to_sheet(table);

    XLSX.utils.book_append_sheet(wb, ws, "Sheet1");
    // XLSX.writeFile(wb, "output.xlsx");

    // var { result, error } = await uploadXlsx(wb, token);
    // // uploadByXHR(wb, token);
    // if (!error) {
    // } else {
    //   console.log(error);
    // }
  };

  // const onSaveAll = useCallback(async () => {
  //   try {
  //     const create = [];
  //     const update = [];
  //     const remove = [];

  //     stateMap.forEach((state, id) => {
  //       if (state === "new") {
  //         const u = localMembers.find((m) => m.id === id);
  //         if (u) create.push(u);
  //       } else if (state === "edited") {
  //         const u = localMembers.find((m) => m.id === id);
  //         if (u) update.push(u);
  //       } else if (state === "deleted") {
  //         remove.push(id);
  //       }
  //     });

  //     const tasks = [];

  //     // --- DELETE ---
  //     for (const id of remove) {
  //       tasks.push(async () => {
  //         // ✅ skip temp id
  //         if (id.startsWith("tmp_")) return { result: null };

  //         const { error, result } = await removeUser(id);
  //         if (error) {
  //           console.log(`Remove user error: ${error}`);
  //         }
  //         return { result: null };
  //       });
  //     }

  //     // --- UPDATE ---
  //     const membersMap = new Map(members.map((m) => [m.id, m]));
  //     for (const u of update) {
  //       tasks.push(async () => {
  //         const org = membersMap.get(u.id);
  //         if (!org) return null;

  //         const changes = {};
  //         for (const f of userFieldKeys) {
  //           if (u[f] !== org[f]) changes[f] = u[f];
  //         }

  //         if (Object.keys(changes).length === 0) return null;

  //         const { error, result } = await updateUser(u.id, changes);
  //         if (error) {
  //           console.log(`Update failed (${u.name}): ${error}`);
  //           return { error };
  //         }
  //         return { result };
  //       });
  //     }

  //     // --- CREATE ---
  //     for (const c of create) {
  //       tasks.push(async () => {
  //         const { id, ...user } = c;
  //         const { error, result } = await createUser(user);
  //         if (error) {
  //           console.log(error);
  //           return { error };
  //         }
  //         return { result };
  //       });
  //     }

  //     const results = await Promise.all(tasks.map((fn) => fn()));
  //     const errors = results.map((r) => r.error).filter(Boolean);

  //     if (errors.length === 0) {
  //       notifySuccess(
  //         `Saved successfully: ${create.length} created, ${update.length} updated, ${remove.length} deleted`,
  //       );
  //     } else {
  //       notifyError(errors.join("\n"));
  //     }

  //     var accounts = localMembers.map((u) => u.email);
  //     // update members
  //     accounts.sort();

  //     if (create.length || remove.length) {
  //       var { error } = await updateDaoTrang(activeDaoTrangId, {
  //         members: accounts,
  //       });
  //       if (error) {
  //         console.log(error);
  //         notifyError(error);
  //       }
  //     }

  //     // update store
  //     const newUsers = results.map((r) => r.result).filter(Boolean);
  //     const changes = { members: newUsers };
  //     dispatch(editDaoTrang({ id: activeDaoTrangId, changes }));
  //   } catch (ex) {
  //     console.log(ex.message);
  //   }
  // }, [
  //   activeDaoTrangId,
  //   daoTrangId,
  //   dispatch,
  //   localMembers,
  //   members,
  //   notifyError,
  //   notifySuccess,
  //   stateMap,
  // ]);

  const onSaveAll = useCallback(async () => {
    console.log("onSaveAll");
    try {
      var accounts = localMembers.map((u) => u.email);
      // accounts.sort();

      // update members
      var { error } = await updateDaoTrang(activeDaoTrangId, {
        members: accounts,
      });
      if (error) {
        console.log(error);
        notifyError(error);
      }

      // update store
      const changes = { members: accounts };
      dispatch(editDaoTrang({ id: activeDaoTrangId, changes }));
    } catch (ex) {
      console.log(ex.message);
    }
  }, [activeDaoTrangId, dispatch, localMembers, notifyError]);
  const onClickBcs = useCallback(async () => {
    navigate("/BCS", { id: daoTrangId });
  }, [daoTrangId, navigate]);

  const onEditClick = useCallback(
    (userId) => {
      console.log(userId);
      navigate("/UserEdit", { id: userId });
    },
    [navigate],
  );

  const onDeleteUser = useCallback(
    async function (userId, daotrangcu) {
      // const { error } = await removeUser(userId);
      // remove user from active dao trang
      // var changes = {
      //   daoTrang: "",
      //   daotrangcu: [daoTrangId, ...daotrangcu.slice(0, 2)],
      // };
      // const { error } = await updateUser(userId, changes);
      // var user = members.find(u=>u.id === userId);
      var changes = {
        members: memberAccounts.filter((u) => u.id !== userId).map((u) => u.email),
      };
      const { error } = await updateDaoTrang(daoTrangId, changes);
      if (!error) {
        dispatch(deleteUser({ userId }));
        dispatch(editDaoTrang({ id: daoTrangId, changes }));
      } else {
        console.log(error);
      }
    },
    [daoTrangId, dispatch, memberAccounts],
  );
  const onChangeUser = useCallback(
    async function ({ userId, change }) {
      dispatch(editUser({ id: userId, changes: change }));
    },
    [dispatch],
  );

  const onSearchKeysChange = useCallback(
    ({ thanhPhan, keys }) => {
      console.log("keys:", keys, ", thanhPhan:", thanhPhan);
      keys !== undefined && dispatch(setKeys({ keys }));
      thanhPhan !== undefined &&
        dispatch(setThanhPhans({ thanhPhans: [thanhPhan] }));
    },
    [dispatch],
  );

  async function handleImport(slectedUsers) {
    const newLst = [];
    const errors = [];
    const createdUsers = [];
    const ids = new Set(localMembers.map((m) => m.id));
    slectedUsers.forEach((u) => {
      if (ids.has(u.id)) {
        // existing
        errors.push(`user ${u.name} existing`);
      } else {
        newLst.push(u);
      }
    });
    const results = await Promise.all(
      newLst.map(async (u) => {
        if (u.id.startsWith("tmp_")) {
          const { id, ...body } = u;
          const { error, result } = await createUser(body);
          if (error) {
            console.log(`create user ${u.name} error: ${error}`);
            errors.push(error);
            return { error };
          } else {
            createdUsers.push(result);
            return { result };
          }
        } else {
          return { result: u };
        }
      }),
    );

    const imported = results.map((r) => r.result).filter(Boolean);

    console.log("handle import: ", { errors, createdUsers, imported });

    setLocalMembersAccounts(localMemberAccounts.concat(imported.map(u=>u.email)));
    if (newLst.length < slectedUsers.length) {
      notifyError(`Imported ${imported.length}/${slectedUsers.length}`);
    } else {
      notifySuccess(`Imported ${slectedUsers.length}`);
    }
    setOpen(false);
  }

  const handleSaveUser = async (changes) => {
    console.log("handleSaveUser: ", changes);

    // save to DB
    const { error, result } = await updateUser(editingUser.id, changes);
    if (error) {
      console.log(`Edit user ${editingUser.name} error: ${error}`);
      return;
    }

    // update store
    dispatch(editUser({ id: editingUser.id, changes }));
  };

  // const workbook = XLSX.read(b64, {type: "base64" });

  const footer = (
    <Box
      spacing={2}
      sx={{ width: "100%", display: "flex", justifyContent: "space-between" }}
    >
      <Button
        variant="outlined"
        disabled={!hasChanges}
        onClick={() => setLocalMembersAccounts(memberAccounts)}
      >
        {"Cancel"}
      </Button>
      <Button variant="contained" disabled={!hasChanges} onClick={onSaveAll}>
        {"Save"}
      </Button>
      {/* <Button variant="contained" onClick={onClickBcs}>
        {"BCS"}
      </Button> */}
    </Box>
  );

  const [open, setOpen] = useState(false);
  const title = (
    <Stack spacing={2} direction="row">
      <Typography variant={"h5"}>All Users</Typography>

      {/* <ImportButton onFileInput={onFileInput}></ImportButton> */}
      <Button variant="contained" onClick={() => setOpen(true)}>
        Import
      </Button>
      {/* <Button
        variant="contained"
        onClick={() => navigate("UserAdd", { daoTrangId: daoTrangId })}
      >
        Add
      </Button> */}

      <Button
        variant="contained"
        onClick={async () => {
          var { error, result } = await loadMember(daoTrangId);
          if (error) {
            notifyError(error);
          } else {
            notifySuccess(`Fetched ${result.length} members!`);
          }
        }}
      >
        Refresh
      </Button>
    </Stack>
  );

  return (
    <>
      <Content
        title={title}
        footer={footer}
        searchBar={UserSearchBar({
          options: createOptions(localMembers),
          handleChange: onSearchKeysChange,
          keys: keys,
          thanhPhan: thanhPhan,
        })}
      >
        <Box sx={{ m: 2 }}>
          <Grid container spacing={2}>
            {getRenderData(localMembers, keys, thanhPhan).map((user, idx) => (
              <Grid item xs={12} sm={6} md={4} key={user.id}>
                <UserCard
                  key={user.id}
                  user={user}
                  onEdit={() => {
                    setEditingUser(user);
                    setOpenEdit(true);
                  }}
                  onDelete={() =>
                    setLocalMembersAccounts((prev) =>
                      prev.filter((u) => u !== user.email),
                    )
                  }
                  state={stateMap.get(user.email)}
                />{" "}
              </Grid>
            ))}

            {/* Add user card */}
            <Grid item xs={12} sm={6} md={4} key={0}>
              <AddUserCard onClick={() => setOpenAdd(true)} />
            </Grid>
          </Grid>
        </Box>
      </Content>

      {/* notify */}
      <NotifySnackbar notify={notify} onClose={close} />

      {/* import dialog */}
      <MyDlg title={"Import User"} open={open} onClose={() => setOpen(false)}>
        <ImportUserStep onImport={handleImport} />
      </MyDlg>

      {/* edit/add user dialog */}
      <EditUserDialog
        title={"Edit User"}
        user={editingUser}
        open={openEdit}
        onClose={() => setOpenEdit(false)}
        onSave={handleSaveUser}
      ></EditUserDialog>

      {/* add or select existing user */}
      <AddUserDialog
        open={openAdd}
        onClose={() => setOpenAdd(false)}
        onSave={async (newUser) => {
          if (localMemberAccounts.some((m) => m === newUser.email)) {
            notifyError("User already exist!");
            return { error: "User already exist!" };
          }

          // add to DB
          // ✅ Case: user mới (temp id) → tạo DB
          if (newUser.id.startsWith("tmp_")) {
            const { id, ...body } = newUser;
            const { error, result } = await createUser(body);

            if (error) {
              console.error(`Create user ${body.name} failed: ${error}`);
              return { error };
            }

            // update store
            dispatch(addUser({ user: result }));

            setLocalMembersAccounts((prev) => [...prev, result.email]);
          } else {
            // ✅ Case: user đã có id (local only)
            setLocalMembersAccounts((prev) => [...prev, newUser.email]);
          }

          setOpenAdd(false);
          return { result: "OK" };
        }}
      />
    </>
  );
};

function MyDlg({ title, open, onClose, children }) {
  return (
    <Dialog open={open} onClose={onClose} fullWidth maxWidth="md">
      <DialogTitle>
        {title}

        {/* Close button */}
        <IconButton
          aria-label="close"
          onClick={onClose}
          sx={{
            position: "absolute",
            right: 8,
            top: 8,
          }}
        >
          <CloseIcon />
        </IconButton>
      </DialogTitle>

      <DialogContent dividers>{children}</DialogContent>
    </Dialog>
  );
}

export default DaoTrang;
async function xlsxImport(e, setWorkbook) {
  const file = e.target.files[0];
  const data = await file.arrayBuffer();
  const workbook = XLSX.read(data);
  console.log(workbook.SheetNames);

  setWorkbook(workbook);
}
